import { Filters } from './filters.model';
import { AppConfigService } from '../../core/services/appConfig.service';
import { ServiceBase } from '../../core/services/serviceBase';

export class InventoryService extends ServiceBase {
  constructor(accessToken: string, entityId: string, config: AppConfigService = new AppConfigService()) {
    super();
    this.accessToken = accessToken;
    this.entityId = entityId;
    this.config = config;
  }

  get environmentUrl() {
    switch (this.config.environment) {
      case 'dms-dev':
      case 'adapter':
        return 'https://api.coxautoinventory-np.com';
      case 'dms-stargate':
      case 'stargate':
        return 'https://api-stargate.coxautoinventory.com';
      case 'dms-int':
      case 'int':
        return 'https://api-int.coxautoinventory.com';
      case 'dms-prod':
      case 'prod':
        return 'https://api.coxautoinventory.com';
      default:
        return 'https://api.coxautoinventory-np.com';
    }
  }

  getVehicles(filters, rehydrate) {
    const baseUrl = `${this.environmentUrl}/api/inventory${filters}`;
    const headers = super.getAuthHeaders(this.accessToken, this.entityId);
    headers.append('X-CoxAuto-Rehydrate', rehydrate);

    return fetch(baseUrl, { headers })
      .then(super.handleApiErrors)
      .then(response => response.json())
      .catch(err => super.handleNetworkError(err));
  }

  getVehicleFilters() {
    const baseUrl = `${this.environmentUrl}/api/inventory/summary`;
    const headers = super.getAuthHeaders(this.accessToken, this.entityId);

    return fetch(baseUrl, { headers })
      .then(super.handleApiErrors)
      .then(response => response.json())
      .catch(err => super.handleNetworkError(err));
  }

  getQuery = (pageSize: number, currentPage: number, filters: Filters) => {
    let query = `?limit(${currentPage ? currentPage : 1},${pageSize})`;

    // Apply Filters
    if (filters) {
      const types = filters.inventoryType.types;
      if (types.length) {
        query += '&';
        if (types.length === 2) {
          query += 'or(';
        }

        for (let i = 0; i < types.length; i++) {
          query += `eq(type,${types[i]})${i === types.length - 1 ? '' : ','}`;
        }

        if (types.length === 2) {
          query += ')';
        }
      }

      const vin = filters.vin;
      if (vin !== '') {
        query += `&eq(vin,${vin})`;
      }

      const stockNumber = filters.stockNumber;
      if (stockNumber !== '') {
        query += `&eq(stocknumber,${stockNumber})`;
      }

      const make = filters.make.value;
      if (make !== '') {
        query += `&eq(make,${make})`;
      }

      const year = filters.year.value;
      if (year !== '') {
        query += `&eq(year,${year})`;
      }

      const model = filters.model.value;
      if (model !== '') {
        query += `&eq(model,${model})`;
      }

      const trim = filters.trim.value;
      if (trim !== '') {
        query += `&eq(trim,${trim})`;
      }
    }

    return query;
  };
}



// WEBPACK FOOTER //
// ./src/components/vehicles/inventory.service.js